import { LedgerCodeModel } from 'src/app/admin/admin-home/admin-fee-definition/ledger-codes/ledger-code.model';
import { IFeeDefinitionModel } from 'src/app/admin/admin-home/admin-fee-definition/fee-definition-model';
export enum RequirementType {
  Regular = 'Regular',
  Payment = 'Payment',
}
export enum FeeAdjustmentConditionOperator {
  After = 'After',
  Before = 'Before',
}
export enum FeeAdjustmentActionType {
  Add = 'Add',
  Subtract = 'Subtract',
}
/** maps to CredentialFeeDefinitionWithIdModel */
export interface ICredentialFeeDefinitionWithIdModel extends ICredentialFeeDefinitionModel {
  id: string;
  credentialDefinitionId: string;
  scenarioWithCredentialFeeDefinitions: { id: string; name: string }[];
}

/** maps to CredentialFeeDefinitionModel */
export interface ICredentialFeeDefinitionModel {
  baseAmount: IFeeDefinitionModel;
  outOfStateAmount: IFeeDefinitionModel;
  inState?: string;
  feeAdjustments: IPaymentRequirementFeeAdjustment[];
}

export interface IScenarioRequirementBase {
  name: string;
  description: string;
  type: RequirementType;
}

export interface IPaymentRequirementFeeAdjustment {
  id: string;
  description: string;
  fee: number;
  actionType: FeeAdjustmentActionType;
  starts: IFeeAdjustmentCondition;
  ends: IFeeAdjustmentCondition;
  ledgerCode: LedgerCodeModel;
  ledgerCodeId: string;
}

export interface IFeeAdjustmentCondition {
  days: number;
  operator: FeeAdjustmentConditionOperator;
}

export class ScenarioRequirementDefinition implements IScenarioRequirementBase {
  type: RequirementType;

  constructor(
    public id: string,
    public name: string,
    public description: string,
    type: RequirementType
  ) {
    this.type = RequirementType[type];
  }

  static parse = (obj: any): ScenarioRequirementDefinition =>
    new ScenarioRequirementDefinition(obj.id, obj.name, obj.description, obj.type);
}
